import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, Grid, Typography } from '@material-ui/core';
import { useIsDesktop } from 'components/utilities';

const InfoListItem = ({
	icon: Icon,
	info,
	description,
	actions,
	...restProps
}) => {
	const isDesktop = useIsDesktop();

	return (
		<ListItem {...restProps}>
			<Grid container spacing={1} justify="space-between" wrap="nowrap">
				<Grid item xs="auto">
					<Grid container spacing={1} alignItems="center" wrap="nowrap">
						<Grid item xs="auto">
							<Icon fontSize={isDesktop ? 'large' : 'default'} />
						</Grid>
						<Grid item xs="auto">
							<Typography>{info}</Typography>
							{description && (
								<Typography variant="h6" color="secondary">
									{description}
								</Typography>
							)}
						</Grid>
					</Grid>
				</Grid>
				{actions && (
					<Grid item xs="auto">
						{actions}
					</Grid>
				)}
			</Grid>
		</ListItem>
	);
};

InfoListItem.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	info: PropTypes.string,
	icon: PropTypes.elementType,
	actions: PropTypes.node,
};

export default InfoListItem;
